import React from "react";
import Button from "@mui/material/Button";
import axios from "axios";

const baseAPI = process.env.REACT_APP_API_URL + "/admin"

const Admin = () => {
  const [ busy, setBusy ] = React.useState(false);
  const [ isDeploying, setIsDeploying ] = React.useState(false);
  const [ msg, setMsg ] = React.useState("NOTE: Copying from wordpress will take several minutes, and the result will only be viewable once the copy is complete");

  React.useEffect(()=>{
    const interval = setInterval(updateIsDeploying, 2000);
    return () => clearInterval(interval);
  }, []);

  const doDeploy = async (url) => {
    setBusy(true);
    setIsDeploying(true);
    const result = await axios.post(`${baseAPI}/${url}`, {}, {withCredentials:true});
    if (result.status===200 && result.data.ok) {
      setMsg("Deploy started. It will take several minutes to complete.");
    } else {
      setMsg("Failed to start deploy.");
      setIsDeploying(false);
    }
    setBusy(false);
  }

  const updateIsDeploying = async() => {
    const result = await axios.post(`${baseAPI}/isDeployRunning`, {}, {withCredentials:true});
    const isRunning = (result.status===200 && result.data.running)
    setIsDeploying(isRunning);
    setBusy(isRunning);
  }

  return <>
  <div className="container">
    <div className="row justify-content-center align-items-center" style={{"textAlign":"center"}}>
      <div className="m-4">{msg}</div>

      {isDeploying && <>
        <div className="m-4">DEPLOY RUNNING</div>
      </>}
      {!isDeploying && <>
        <div className="m-4">No deploy running</div>
      </>}

      <div className="m-4">
        <Button variant="contained"
            disabled={busy}
            onClick={()=>doDeploy("deploy")}
        >
          Copy from wordpress to {window.location.hostname}
        </Button>
      </div>
    </div>    
  </div>
  </>
}

export default Admin;
